import { render, staticRenderFns } from "./FindComponent.vue?vue&type=template&id=edda6126&scoped=true"
import script from "./FindComponent.vue?vue&type=script&lang=js"
export * from "./FindComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda6126",
  null
  
)

export default component.exports